import React from 'react';
import { Col, Row, Skeleton } from 'antd';
import { SkeletonFormItem } from 'common/components/Skeleton/SkeletonFormItem';

interface IComponentProps {
  isEdit: boolean;
}

export const BitecoinRewardFormSkeleton: React.FC<IComponentProps> = (props) => {
  const { isEdit } = props;

  return (
    <div className="mt-5">
      <span className="basic__text_title" title="General info">
        General info
      </span>
      <Row gutter={[28, 0]}>
        <Col span={12}>
          <SkeletonFormItem label="Reward Category">
            <Skeleton.Input active />
          </SkeletonFormItem>
        </Col>
        <Col span={12}>
          <SkeletonFormItem label="Reward name">
            <Skeleton.Input active />
          </SkeletonFormItem>
        </Col>
      </Row>
      <Row gutter={[28, 0]}>
        <Col span={12}>
          <SkeletonFormItem label="Menu item">
            <Skeleton.Input active />
          </SkeletonFormItem>
        </Col>
      </Row>

      <span className="basic__text_title" title="Reward settings">
        Reward settings
      </span>
      <Row gutter={[28, 0]}>
        <Col span={12}>
          <SkeletonFormItem label="Reward type">
            <Skeleton.Input active />
          </SkeletonFormItem>
        </Col>
      </Row>

      <Row className="flex-noWrap" justify="space-between" align="middle">
        <Col span={16}>
          <Skeleton.Button className="mr-5" />
          <Skeleton.Button />
        </Col>
        {isEdit && (
          <Col>
            <Skeleton.Button />
          </Col>
        )}
      </Row>
    </div>
  );
};
